<div class="loading" *ngIf="show">
  <div class="spinner">
    <mat-progress-spinner
      class="example-margin"
      [color]="color"
      [mode]="mode"
      [value]="value"
      [diameter]="150"
    >
    </mat-progress-spinner>
    <!-- centralizar -->
    <div class="text">
      {{ getValue() }}
    </div>
  </div>
</div>
